import { Fragment, ReactElement } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import ActionsList from './actions';

interface ResearchDeathNotificationResidentSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const ResearchDeathNotificationResidentShared = ({
  goBackUrl = '',
  redirectUrl = '',
  items = [],
}: ResearchDeathNotificationResidentSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items} />
      <PersonSearch
        pathname={redirectUrl}
        action={ActionsList}
        addedTitle="- Cancellazione per morte"
        url={`${__PERSON_NEW_API_URL__}/ricerca-persona/cancellazione-morte`}
        goBackUrl={goBackUrl}
      />
    </Fragment>
  );
};

ResearchDeathNotificationResidentShared.displayName =
  'Research Marriage Notifications Resident Page component';

export default ResearchDeathNotificationResidentShared;
